import { gql } from "@apollo/client";
import { skipToken, useSuspenseQuery } from "@apollo/client/react";

import Parameter from "./Parameter.graphql";
import { taxonomy } from "../../modules/api";

export default function useParameter(id: string) {
    return useSuspenseQuery(
        gql(Parameter),
        id
            ? {
                client: taxonomy,
                variables: {
                    id,
                },
            }
            : skipToken,
    );
}
